import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Tooltip, Spin} from 'antd';
import styles from './style.module.scss';
import {faCheck, faPlus, faTimes} from '@fortawesome/pro-light-svg-icons';
import {useStore} from '@/store/root-store';
import {LoadingOutlined} from '@ant-design/icons';
import {observer} from 'mobx-react';
import classNames from 'classnames';

interface Props {
  keyword: string;
  isIncluded?: boolean;
}

export const SimilarKeyword = observer(({keyword, isIncluded}: Props) => {
  const {
    OverviewPage: {
      addToLoadingArray,
      loadingArray,
    },
    contentOptimizer: {currentPage},
  } = useStore('');
  const {settings: {customer: {profile: {quotaUtilization}, getCustomerQuota}}, plans: {showSidebarPaymentDrawer}} = useStore('');

  const antIcon = <LoadingOutlined style={{fontSize: 16, color: '#7f4ead', marginRight: '10px'}} spin />;

  const onAddKeywordFinish = async () => {
    if (currentPage.feTargetKeywords && currentPage.feTargetKeywords?.filter(kw => JSON.stringify({
      keyword: kw.keyword,
      countryCode: kw.countryCode,
      locationId: kw.locationId,
      location: kw.location,
    }) === JSON.stringify({
      keyword: keyword,
      countryCode: currentPage.content.countryCode,
      locationId: currentPage.content.locationId,
      location: currentPage.content.location,
    })).length) {
      return;
    }
    addToLoadingArray(keyword);

    const newKwLocation = {
      location: currentPage.content.location,
      locationId: currentPage.content.locationId,
      countryCode: currentPage.content.countryCode,
    };

    const formatArray = [...currentPage.feTargetKeywords, {
      keyword: keyword,
      ...newKwLocation,
    }];

    currentPage.updateFeTargetKeywords(formatArray);

    try {
      await currentPage?.editKeywords({keyword: keyword, ...newKwLocation}, 'add');
      getCustomerQuota();
    } catch (err) {
      if (err?.response?.status === 429) {
        showSidebarPaymentDrawer(null, {title: 'You need more Content Genius focus terms quota to continue', subtitle: '', text: `Current limit: ${quotaUtilization?.ca?.allowedFocusTerms?.total} lookups`});
      }
      return Promise.reject(err);
    }
  };
  const onRemoveKeywordFinish = async () => {
    addToLoadingArray(keyword);


    const formatArray = [...currentPage.feTargetKeywords].filter(kw => JSON.stringify({
      keyword: kw.keyword,
      countryCode: kw.countryCode,
      locationId: kw.locationId,
      location: kw.location,
    }) !== JSON.stringify({
      keyword: keyword,
      countryCode: currentPage.content.countryCode,
      locationId: currentPage.content.locationId,
      location: currentPage.content.location,
    }));
    currentPage.updateFeTargetKeywords(formatArray);

    const newKwLocation = {
      location: currentPage.content.location,
      locationId: currentPage.content.locationId,
      countryCode: currentPage.content.countryCode,
    };

    try {
      await currentPage?.editKeywords({keyword: keyword, ...newKwLocation}, 'delete');
      getCustomerQuota();
    } catch (err) {
      if (err?.response?.status === 429) {
        showSidebarPaymentDrawer(null, {title: 'You need more Content Genius focus terms quota to continue', subtitle: '', text: `Current limit: ${quotaUtilization?.ca?.allowedFocusTerms?.total} lookups`});
      }
      return Promise.reject(err);
    }
  };

  return <div style={{width: '100%', display: 'flex'}}>
    <Tooltip title={keyword || ''}>
      <div className={styles.titleText} style={{maxWidth: '100px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', display: 'block', marginRight: '8px', marginTop: '3px'}}>{keyword ? keyword : '-'}</div>
    </Tooltip>
    <div style={{width: '120px'}}>

      {loadingArray && loadingArray.includes(keyword) ?
        <Spin indicator={antIcon} /> : isIncluded ?
          <div className={styles.addedToProjectBtn} onClick={() => onRemoveKeywordFinish()}>
            <FontAwesomeIcon icon={faTimes} style={{color: '#F44343', margin: 'auto 6px auto 6px', fontSize: '15px'}} className={styles.iconRemove}/>
            <FontAwesomeIcon icon={faCheck} style={{color: '#2AC155', margin: 'auto 6px auto 6px', fontSize: '15px'}} className={styles.iconAdded}/>
            <span className={styles.addedToProjectBtnExpanded}>Remove</span>
          </div> :
          // adding a check to disable button if total target kw limit is reached
          currentPage?.feTargetKeywords?.length < 15 ?
            <div className={styles.addToProjectBtn} onClick={() => onAddKeywordFinish()}>
              <FontAwesomeIcon icon={faPlus} style={{color: '#2D6CCA', margin: 'auto 6px auto 6px', fontSize: '15px'}}/>
              <span className={styles.addToProjectBtnExpanded}>Add to Project</span>
            </div> :
            <Tooltip title={`Cannot add more than 15 target keywords.`}>
              <div className={classNames(styles.addToProjectBtn, styles.disabledBtn)}>
                <FontAwesomeIcon icon={faPlus} style={{color: '#2D6CCA', margin: 'auto 6px auto 6px', fontSize: '15px'}}/>
              </div>
            </Tooltip>

      }

    </div>
  </div>;
});
